/**
 * Legacy: prefer [Media], which renders the still as a real `Image` layered
 * under the video — responsive, lazy, placeheld, and named once.
 *
 * A `poster` attribute built by hand reaches the optimizer but nothing else:
 * one fixed width, no srcset, no priority, and fetched the moment the element
 * mounts however `preload` is set. Its remaining call sites are the /product
 * visual zone's films and clips, still to move onto [Media]. Do not add more.
 */

/** Next's `imageSizes` then `deviceSizes`; anything else 400s at the optimizer. */
type OptimizedPosterWidth =
  | 16
  | 32
  | 48
  | 64
  | 96
  | 128
  | 256
  | 384
  | 640
  | 750
  | 828
  | 1080
  | 1200
  | 1920
  | 2048
  | 3840;

export const optimizedPoster = (
  src: string,
  width: OptimizedPosterWidth,
): string => `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=75`;
